/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EditorDocStrategyType {
    OBSTACLES_AND_OPPORTUNITIES = 'OBSTACLES_AND_OPPORTUNITIES',
    GUIDING_PRINCIPLES = 'GUIDING_PRINCIPLES',
}
